import React, { useState, useEffect, useMemo } from 'react'
import useIsInViewport from 'use-is-in-viewport'

import Container from '../../../utils/Container'
import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Button from '../../../elements/buttons/Button'
import ProgressiveImg from '../../../elements/images/ProgressiveImg'
import Loader from '../../../utils/Loader'
import typing from '../../../../medias/images/Typing-bro.png'


const HireTraductor = () => {

	const [isInViewport, targetRef] = useIsInViewport()

	return (
		<section
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv" } mt-28 md:mt-28`}
		>

			<Container>
				<div className=" py-10 md:py-20 flex flex-col md:flex-row items-center">
					<Heading2 classe="md:hidden text-center">Pourquoi faire appel à un traducteur professionnel ?</Heading2>
					<ProgressiveImg
						src={typing}
						classe="w-64 md:w-96 h-auto mt-5 md:mt-0"
						alt="une redactrice qui manipule son ordinateur"
					/>

					<div className="md:ml-6 lg:ml-16">
						<Heading2 classe="hidden md:block">Pourquoi faire appel à un traducteur professionnel ?</Heading2>
						<div className="flex flex-col space-y-5 mt-5">
							<Paragraph>
								Le traducteur professionnel maîtrise la plupart du temps une ou deux langues en plus de sa langue maternelle. Il connaît les nuances des langues qu’il maîtrise et pourra donc rendre une traduction très proche des intentions de l’auteur originel, contrairement aux traducteurs automatiques disponibles. 
							</Paragraph>
							<Paragraph>
								Ainsi, faire appel à un traducteur professionnel pour la traduction de votre site, documents, application ou publicité vous permettra d’être certain d’atteindre le résultat escompté .
							</Paragraph>
						</div>

						<div className="mt-8 flex justify-center md:block">
							<Button
								link="/faqs"
							>
								voir FAQS
							</Button>
						</div>
					</div>
				</div>
				
			</Container>
		</section>
	)
}


const Statistiques = ({ chiffre, text }) => {

	return(
		<div className="flex flex-col items-center">
			<span className="font-primary text-gray-800 font-xs block text-5xl md:text-6xl lg:text-7xl">{chiffre}</span>
			<span className="font-secondary text-sm md:text-lg text-gray-500 text-center">{text}</span>
		</div>
	)
}

export default HireTraductor